import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import BaseManagedServices from '../../AbstractObjects/GatewayPlan/InnerPages/BaseManagedServices';
import {useTranslation} from 'react-i18next';
import {managedServicesIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.managedServices;
const pageId = pageSchema.pageId;

function GatewayManagedServices({
    gatewayObject,
    planObject,
    setGatewayData
}) {
    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];
    const { t } = useTranslation();

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData(pageId, planPage);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);

    return (
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMP.GATEWAYS.INNER_MENU.MANAGED_SERVICES')}
            icon={managedServicesIcon}
        >
            <BaseManagedServices
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
            />
        </LockToPlanContainer>
    );
}

export default GatewayManagedServices;